import { render, staticRenderFns } from "./DragDeviceList.vue?vue&type=template&id=0f80d318&scoped=true&"
import script from "./DragDeviceList.vue?vue&type=script&lang=js&"
export * from "./DragDeviceList.vue?vue&type=script&lang=js&"
import style0 from "./DragDeviceList.vue?vue&type=style&index=0&id=0f80d318&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f80d318",
  null
  
)

export default component.exports